import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Refresh2Light(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", d: "m14 15-4 4 4 4" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M18.062 8.5a7 7 0 0 1-6.937 10.445" }), _jsx("path", { stroke: "currentColor", d: "m10 9 4-4-4-4" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5.938 15.5a7 7 0 0 1 7.158-10.414" })] }) });
}
const Refresh2Light = forwardRef(_Refresh2Light);
export { Refresh2Light };
